import { type FC } from 'react';

import { SingleMenuItem } from '$/components/core/Collection/CollectionFilter/components/SingleMenuItem';
import { type FilterOptionGroup } from '$/services/usecases/filter';
import { useCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  filter: FilterOptionGroup;
  onMenuClose: () => void;
  hideAmounts?: boolean;
  itemWidth?: string;
  compactMode?: boolean;
}

export const SingleFilter: FC<Props> = ({
  onMenuClose,
  filter,
  hideAmounts,
  itemWidth = '16rem',
  compactMode = false,
}) => {
  const isFilterActive = useCollectionStore.useIsFilterActive();

  return filter.items.map((filterItem) => {
    const activate = () => {
      useCollectionStore.getState().toggleAppliedFilterOption({
        option: filter.searchField,
        value: filterItem.value,
      });

      onMenuClose();
    };

    return (
      <SingleMenuItem
        key={filterItem.value}
        name={filterItem.displayName}
        isActive={isFilterActive(filter.searchField, filterItem.value)}
        amount={hideAmounts ? undefined : filterItem.count}
        onClick={activate}
        w={itemWidth}
        compactMode={compactMode}
        data-testid={`${filter.searchField}-${filterItem.value}`}
      />
    );
  });
};
